'use client'

import { useState } from 'react'

import Fuse from 'fuse.js'
import { SearchIcon } from 'lucide-react'

import { useLibraryStore } from '../stores/useLibraryStore'

import { Document } from '@/features/library/types/document'
import { useModalContext } from '@/shared/contexts/Modal'
import { cn } from '@/shared/lib/utils'
import { Card, CardHeader, CardBody, CardTitle } from '@/shared/ui/Card'
import { Input } from '@/shared/ui/input'
import { inputClassName } from '@/shared/ui/input-styles'

import { DocumentCard } from './DocumentCard'
import { DocumentModal } from './DocumentModal'


export const DocumentsList = () => {
  const { documents } = useLibraryStore()
  const { openModal } = useModalContext()
  const [search, setSearch] = useState('')
  const hasSearch = !!search.trim()
  const fuse = new Fuse(documents, {
    keys: ['name', 'description'],
    threshold: 0.3
  })

  const handleClick = (document: Document) => {
    openModal(
      {
        modal: DocumentModal
      },
      {
        documentId: document.id
      }
    )
  }

  const handleSearchChange = (value: string) => {
    setSearch(value)
  }

  return (
    <div className="flex flex-col gap-4 w-full items-center">
      <Card variant="purple">
        <CardHeader>
          <CardTitle>Biblioteca</CardTitle>
        </CardHeader>
        <CardBody>
          <div className="flex items-center relative h-[41px] mb-6">
            <Input
              className={cn(inputClassName, 'mb-0')}
              placeholder="Busca textual"
              value={search}
              onChange={e => handleSearchChange(e.target.value)}
            />
            <button className="absolute right-0 top-0 h-full bg-jacaranda text-white px-5 rounded-r-md inset-shadow-[0_-3px_0_0_#6B64B7]">
              <SearchIcon className="" />
            </button>
          </div>
          <div className="flex flex-col gap-4">
            {hasSearch
              ? fuse
                  .search(search)
                  .map(doc => (
                    <DocumentCard
                      key={doc.item.id}
                      document={doc.item}
                      onClick={() => handleClick(doc.item)}
                    />
                  ))
              : documents.map(document => (
                  <DocumentCard
                    key={document.id}
                    document={document}
                    onClick={() => handleClick(document)}
                  />
                ))}
          </div>
        </CardBody>
      </Card>
    </div>
  )
}
